export type ChatUnreadSource =
  | 'desktop_nav'
  | 'mobile_tab'
  | 'panel_minimized';

export type ChatUnreadCountBucket = '1' | '2-9' | '10-99' | '99+';

export type ChatUnreadTelemetryEvent =
  | {
      name: 'chat_unread_badge_shown';
      count_bucket: ChatUnreadCountBucket;
    }
  | {
      name: 'chat_opened_from_unread';
      source: ChatUnreadSource;
      count_bucket: ChatUnreadCountBucket;
    };

export type ChatUnreadTelemetrySink = (
  event: ChatUnreadTelemetryEvent
) => void;

let telemetrySink: ChatUnreadTelemetrySink | undefined;

export const getChatUnreadCountBucket = (
  count: number
): ChatUnreadCountBucket => {
  if (count === 1) return '1';
  if (count < 10) return '2-9';
  if (count < 100) return '10-99';
  return '99+';
};

export const emitChatUnreadTelemetry = (
  event: ChatUnreadTelemetryEvent
): void => {
  try {
    telemetrySink?.(event);
  } catch {
    // Telemetry must never prevent Chat from opening or updating.
  }
};

export const setChatUnreadTelemetrySink = (
  sink?: ChatUnreadTelemetrySink
): (() => void) => {
  telemetrySink = sink;

  return () => {
    if (telemetrySink === sink) telemetrySink = undefined;
  };
};
